import React, { Component } from "react"
import { bindActionCreators } from "redux"
import { connect } from "react-redux"
import _ from "lodash"
import moment from "moment"
import Title from "../general/title"
import { loadingStatus } from "actions"
import ImageExport from "components/ImageExport"
import numeral from "numeral"
import FullTable from "components/FullTable"
import helpers from "helpers/helpers"
import axios from "axios"
import settings from "settings"

class RealtorDetail extends Component {
	constructor(props) {
		super(props)
		this.state = {
			id: 0,
			data: {},
			sorted: [],
			filtered: [],
			offices: "",
			latestOffice: "",
			columns: [
				{
					Header: "Sold Address",
					accessor: "address",
					filterMethod: (f, r) => helpers.tableText(f, r, "address"),
				},
				{
					Header: "Builder",
					accessor: "builder",
					filterMethod: (f, r) => helpers.tableText(f, r, "builder"),
				},
				{
					Header: "Salesperson",
					accessor: "salesperson",
					filterMethod: (f, r) => helpers.tableText(f, r, "salesperson"),
				},
				{
					Header: "Price",
					accessor: "price",
					Cell: (props) => numeral(props.value).format("$0,0"),
					sort: "desc",
					filterMethod: (f, r) => helpers.dateFilter(f, r),
				},
				{
					Header: "Contract Date",
					accessor: "sale_date",
					Cell: (props) => moment.unix(props.value).format("MM/DD/YY"),
					sort: "desc",
					filterMethod: (f, r) => helpers.dateFilter(f, r),
				},
				{
					Header: "Cancel Date",
					accessor: "cancel_date",
					Cell: (props) => {
						if (props.value) {
							return moment.unix(props.value).format("MM/DD/YY")
						}
						return ""
					},
					sort: "desc",
					filterMethod: (f, r) => helpers.dateFilter(f, r),
				},
				{
					Header: "Closing Date",
					accessor: "closingDate",
					Cell: (props) => {
						if (props.value) {
							return moment.unix(props.value).format("MM/DD/YY")
						}
						return ""
					},
					filterMethod: (f, r) => helpers.dateFilter(f, r),
					sort: "desc",
				},
			],
			closingColumns: [
				{
					Header: "Sold Address",
					accessor: "address",
					filterMethod: (f, r) => helpers.tableText(f, r, "address"),
				},
				{
					Header: "Builder",
					accessor: "builder",
					filterMethod: (f, r) => helpers.tableText(f, r, "builder"),
				},
				{
					Header: "Salesperson",
					accessor: "salesperson",
					filterMethod: (f, r) => helpers.tableText(f, r, "salesperson"),
				},
				{
					Header: "Price",
					accessor: "price",
					Cell: (props) => numeral(props.value).format("$0,0"),
					sort: "desc",
					filterMethod: (f, r) => helpers.dateFilter(f, r),
				},
				{
					Header: "Contract Date",
					accessor: "sale_date",
					Cell: (props) => moment.unix(props.value).format("MM/DD/YY"),
					sort: "desc",
					filterMethod: (f, r) => helpers.dateFilter(f, r),
				},
				{
					Header: "Closing Date",
					accessor: "closingDate",
					Cell: (props) => {
						if (props.value) {
							return moment.unix(props.value).format("MM/DD/YY")
						}
						return ""
					},
					filterMethod: (f, r) => helpers.dateFilter(f, r),
					sort: "desc",
				},
			],
		}
	}

	componentDidMount() {
		this.setState({ id: parseInt(this.props.match.params.id) }, () => {
			this.getData()
		})
	}

	componentDidUpdate(prev) {
		if (this.state.id !== parseInt(this.props.match.params.id)) {
			this.setState({ id: parseInt(this.props.match.params.id) }, () => {
				this.getData()
			})
		}
	}

	getData = () => {
		this.props.loadingStatus(true)
		let userToken = localStorage.getItem("user")
		axios
			.post(
				settings.ep + "/getRealtor",
				{ license: this.state.id },
				{
					headers: { Authorization: `Bearer ${userToken}` },
				}
			)
			.then((response) => {
				if (response.data.status == 200) {
					let offices = []
					let latestOffice = ""
					_.forEach(this.props.payload.sales.current, (r) => {
						if (parseInt(r.realtor) == this.state.id && r.realtor_name !== r.realtor_office_name) {
							offices.push(r.realtor_office_name)
							latestOffice = r.realtor_office_name
						}
					})
					offices = _.uniq(offices)
					offices = offices.join(", ")
					this.setState({ data: response.data, offices, latestOffice })
				}
				this.props.loadingStatus(false)
			})
			.catch((error) => {})
	}

	buildTable = () => {
		var ret = []
		let offices = []
		_.forEach(this.props.payload.sales.current, (r) => {
			if (parseInt(r.realtor) !== this.state.id) {
				return
			}
			let builder = _.find(this.props.payload.public.builders, { id: r.builder })
			let sp = _.find(this.props.payload.public.salespeople, { id: r.salesperson })
			var v = {}
			v.address = r.address
			v.realtor = r.realtor_name
			v.sale_date = r.sale_date
			v.price = r.price
			v.closingDate = r.closing_date ? r.closing_date : ""
			v.builder = builder ? builder.name : ""
			v.salesperson = sp ? `${sp.first} ${sp.last}` : ""
			ret.push(v)
		})

		ret = _.sortBy(ret, "sale_date").reverse()
		//console.log(ret)
		return ret
	}

	buildClosingsTable = () => {
		var ret = []
		let offices = []
		_.forEach(this.props.payload.closings.current, (r) => {
			if (parseInt(r.realtor) !== this.state.id) {
				return
			}
			let builder = _.find(this.props.payload.public.builders, { id: r.builder })
			let sp = _.find(this.props.payload.public.salespeople, { id: r.salesperson })
			var v = {}
			v.address = r.address
			v.realtor = r.realtor_name
			v.sale_date = r.sale_date
			v.price = r.price
			v.closingDate = r.closing_date ? r.closing_date : ""
			v.builder = builder ? builder.name : ""
			v.salesperson = sp ? `${sp.first} ${sp.last}` : ""
			ret.push(v)
		})

		ret = _.sortBy(ret, "sale_date").reverse()
		//console.log(ret)
		return ret
	}

	buildTotalSales = () => {
		if (_.has(this.props, "payload.builders")) {
			var keys = Object.keys(this.props.payload.builders)
			return keys.map((v, i) => {
				var total = 0
				this.props.payload.sales.current.forEach((val) => {
					if (val.builder_id == v) {
						total += 1
					}
				})
				return (
					<li className="statBreakout__item" key={i}>
						<div>
							<div className="statBreakout__stat">{total}</div>
							<div className="statBreakout__info">{this.props.payload.builders[v]}</div>
						</div>
					</li>
				)
			})
		}
	}

	realtorInvolved = () => {
		var count = 0
		if (_.has(this.props, "payload.sales.current")) {
			_.forEach(this.props.payload.sales.current, (r) => {
				if (parseInt(r.realtor) !== this.state.id) return
				count++
			})
		}

		return <React.Fragment>{count}</React.Fragment>
	}

	realtorClosings = () => {
		var count = 0
		if (_.has(this.props, "payload.closings.current")) {
			_.forEach(this.props.payload.closings.current, (r) => {
				if (parseInt(r.realtor) !== this.state.id) return
				count++
			})
		}

		return <React.Fragment>{count}</React.Fragment>
	}

	realtorClosingsValue = () => {
		var total = 0
		if (_.has(this.props, "payload.closings.current")) {
			_.forEach(this.props.payload.closings.current, (r) => {
				if (parseInt(r.realtor) !== this.state.id) return
				total += r.price
			})
		}
		let ret = numeral(total).format("$0,0")
		return ret
	}

	realtorSalesValue = () => {
		var total = 0
		if (_.has(this.props, "payload.sales.current")) {
			_.forEach(this.props.payload.sales.current, (r) => {
				if (r.bustout_date || parseInt(r.realtor) !== this.state.id) return
				total += r.price
			})
		}
		let ret = numeral(total).format("$0,0")
		return ret
	}

	render() {
		if (this.state.data.realtor) {
			return (
				<div className="realtorReport">
					<div className="imageGroup">
						<Title title="Realtor Detail" />
						<div className="realtorDetail">
							<div className="realtorDetail__box">
								<ul className="realtorDetail__list">
									<li>
										<span>Name</span>
										{this.state.data.realtor.full_name}
									</li>
									<li>
										<span>License</span>
										{this.state.data.realtor.license}
									</li>
									<li>
										<span>Email</span>
										<a href={`mailto:${this.state.data.realtor.email}`}>
											{this.state.data.realtor.email}
										</a>
									</li>
									<li>
										<span>Phone</span>
										{this.state.data.realtor.phone}
									</li>
									<li>
										<span>Address</span>
										{`${this.state.data.realtor.mailing_address_1} ${this.state.data.realtor.mailing_address_city} ${this.state.data.realtor.mailing_address_state} ${this.state.data.realtor.mailing_address_zip}`}
									</li>
								</ul>
							</div>
						</div>
						<div className="realtorDetail__offices">
							<div className="realtorDetail__officesCont content">
								<div>
									<span>All Offices</span>
									{this.state.offices}
								</div>
								{this.state.latestOffice && (
									<div>
										<span>Latest Office</span>
										{this.state.latestOffice}
									</div>
								)}
							</div>
						</div>
						<div className="statBreakout">
							<ul className="boxList__list">
								<li className="boxList__item">
									<span>{this.realtorInvolved()}</span>
									<br />
									<span>Sales</span>
								</li>
								<li className="boxList__item">
									<span>{this.realtorClosings()}</span>
									<br />
									<span>Closings</span>
								</li>
								<li className="boxList__item boxList__item--small">
									<span>{this.realtorSalesValue()}</span>
									<br />
									<span>Sales Value</span>
								</li>
								<li className="boxList__item boxList__item--small">
									<span>{this.realtorClosingsValue()}</span>
									<br />
									<span>Closings Value</span>
								</li>
							</ul>
						</div>
					</div>
					<div className="imageGroup">
						<div className="content">
							<ImageExport name="RealtorSalesTable" />
							<h2>
								Sales for {this.props.currentDates.startText} - {this.props.currentDates.endText}
							</h2>
							<FullTable
								data={this.buildTable()}
								columns={this.state.columns}
								name="realtorDetail__involvedSales"
								title="Realtor Sales"
							/>
							<h2>
								Closings for {this.props.currentDates.startText} - {this.props.currentDates.endText}
							</h2>
							<FullTable
								data={this.buildClosingsTable()}
								columns={this.state.closingColumns}
								name="realtorDetail__closings"
								title="Realtor Closings"
							/>
						</div>
					</div>
				</div>
			)
		}
		return ""
	}
}

function mapStateToProps(state) {
	return {
		currentDates: state.currentDates,
		compareDates: state.compareDates,
		payload: state.payload,
	}
}

function matchDispatchToProps(dispatch) {
	return bindActionCreators(
		{
			loadingStatus,
		},
		dispatch
	)
}

export default connect(mapStateToProps, matchDispatchToProps)(RealtorDetail)
